import { EFormRow } from './e-form-row.model';
import { EFormControl } from './e-form-control.model';
import { EFormConfiguration, enmEFormViewModes } from './e-form-config.model';

export class EFormColumn {
    Id: number;
    Height = 100;
    Rows: EFormRow[] = [];
    Controls: EFormControl[] = [];
    Alignment = 'flex-start';
    Width: string;
    FixedWidth: boolean;
    Indent: string;

    // Tree View Property
    Expanded: boolean;

    constructor (config: EFormConfiguration) {
        if (config.ViewMode == enmEFormViewModes.Page) {
            this.Indent = '38';
        }
    }
}